import axios, { AxiosResponse } from "axios";
import useAuthHeaders from "hooks/useAuthHeader";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { useQuery } from "react-query";
import { DashboardTopSearchResponse } from "types/dashboard-top-search";


interface GetAllTopSearch extends AxiosResponse {
    data: DashboardTopSearchResponse
}

const useTopSearch = () => {
    const signOut = useSignOut();
    const headers = useAuthHeaders();


    return useQuery<unknown, unknown, GetAllTopSearch>({
        queryKey: ['get-all-top-search'],
        queryFn: async () => {
            try {
                return await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/top/search`, { headers })
            } catch (err) {
                console.error(err);
                if (err?.response?.status === 401) signOut();
            }
        },
    })
}

export default useTopSearch;